import { render, staticRenderFns } from "./UpdateAltCoinModal.vue?vue&type=template&id=3f6dd3e4&scoped=true&"
import script from "./UpdateAltCoinModal.vue?vue&type=script&lang=js&"
export * from "./UpdateAltCoinModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6dd3e4",
  null
  
)

export default component.exports